<template>
<div class="grid-item bg-temp" v-flash="'7in1'"><AirTemperature :temp="temp_c"/></div>
<div class="grid-item bg-hum" v-flash="'7in1'"> <AirHumidity :hum="humidity" /></div>
<div class="grid-item bg-lux" v-flash="'7in1'"> <LightLux :klux="light_klx" /></div>
<div class="grid-item bg-uv" v-flash="'7in1'"> <UvIndex :uvindex="uv_index" /></div>
<div class="grid-item bg-wind" v-flash="'7in1'"><WindValues
                          :speed="wind_speed" 
                          :direction="wind_direction"
                          :wind_dirtext="wind_dirtext"
                          :gust="gust"
                       />
</div>
<div class="grid-item bg-rain" v-flash="'7in1'"><RainMeter
                          :rain="rain"
                          :rain_h="rain_h"
                          :rain_d="rain_d"
                          :rain_w="rain_w"
                          :rain_m="rain_m"
                          />
</div>
</template>

<script>
import AirTemperature from './air_temperature.vue'
import AirHumidity from './air_humidity.vue'
import UvIndex from './uv_index.vue'
import LightLux from './light_lux.vue'
import WindValues from './wind_values.vue'
import RainMeter from './rain_meter.vue'

export default {
  name: 'SevenInOne',
  props: {
    sensorstring: String,
    temp_c: Number,
    humidity: Number,
    light_klx: Number,
    uv_index: Number,
    wind_speed: Number,
    gust: Number,
    wind_direction: Number,
    wind_dirtext: String,
    rain: Number,
    rain_h: Number,
    rain_d: Number,
    rain_w: Number,
    rain_m: Number
  },
  components: {
    AirTemperature,
    AirHumidity,
    UvIndex,
    WindValues,
    LightLux,
    RainMeter
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-temp     { background-color: #CA291C; }
.bg-rain     { background-color: #299A1C; }
.bg-hum      { background-color: #2F666B; }
.bg-lux      { background-color: #296F5F; }
.bg-uv       { background-color: #E3A740; }
.bg-wind     { background-color: #417692; }
</style>
